// Lib
import React from 'react';

import PropTypes from 'prop-types';

// Components
import FullScreenModal from './FullScreenModal';
import FullScreenErrorModal from './FullScreenErrorModal';

const RouteModalRoot = (props) => {
    if (props.isError) {
        return (
            <FullScreenErrorModal overlay {...props}>
                {props.children}
            </FullScreenErrorModal>
        );
    }

    return (
        <FullScreenModal overlay {...props}>
            {props.children}
        </FullScreenModal>
    );
};

RouteModalRoot.propTypes = {
    children: PropTypes.node,

    isError: PropTypes.bool,
};

export default RouteModalRoot;
